import { Component } from '@angular/core';
import { HubContact } from './hub-interfaces/hub-contact.model';
import { HubService } from './hub-interfaces/hub-service.model';

@Component({
  standalone: false,
  selector: 'hub',
  templateUrl: './hub.component.html',
  styleUrl: './hub.component.scss',
})
export class HubComponent {

  contacts: HubContact[] = [
    {
      label: 'Client Relations Manager',
      phone: '0161 603 2139',
      email: 'lucy.muir@supportis.com',
      note: 'if you require login credentials',
    },
    { label: '(24/7) HR Advice Line', phone: '0161 603 2174', email: 'advice@supportis.com' },
    { label: 'Sales', phone: '0161 603 2156', email: 'hello@supportis.com' },
    { label: 'Health & Safety', phone: '0161 414 0506', email: 'leighcolleton@safety2business.com' },
  ];

  services: HubService[] = [
    {
      title: 'S2B Online',
      subtitle: 'My health & safety management portal',
      url: 'https://www.s2bonline.net',
      img: 'assets/images/hub/s2b-online.png',
    },
    {
      title: 'Cirrus',
      subtitle: 'My online HR case management system',
      url: 'https://clientportal.supportis.com',
      img: 'assets/images/hub/cirrus.png',
    },
    {
      title: 'eLearning',
      subtitle: 'My digital learning & development portal',
      url: 'https://supportislearning.unicornlms.com',
      img: 'assets/images/hub/elearning.png',
    },
    {
      title: 'CirrusHR',
      subtitle: 'My absence management & documentation storage system',
      url: 'https://cirrushr.co.uk',
      img: 'assets/images/hub/cirrushr.png',
    },
    {
      title: 'Care Policies',
      subtitle: 'My Health & Social Care care policies system',
      url: 'https://go.accessacloud.com',
      img: 'assets/images/hub/care-policies.png',
    },
  ];

  openService(url: string): void {
    window.open(url, '_blank', 'noopener');
  }
}
